import CollapsibleGroup from "../../../views/cloud/CreateCloudView/CreateCloudComponents/CollapsibleGroup";

interface Props {
  setPage: (newPage: string) => void;
  type: "Quick Create" | "Layout";
}

function SelectionPage({ setPage, type }: Props) {
  return (
    <>
      <CollapsibleGroup
        icon="mdi mdi-plus"
        title={`Create new ${type}`}
        description={`Define your own ${type} specific to this view`}
        collapsible={false}
        onClick={() => setPage("normal")}
      />
      <CollapsibleGroup
        icon="mdi mdi-earth"
        title={`Reuse Cloud ${type}`}
        description={`Add an existing ${type} to this view`}
        collapsible={false}
        onClick={() => setPage("global")}
      />
    </>
  );
}

export default SelectionPage;
